import { render, staticRenderFns } from "./BaseViewMode.vue?vue&type=template&id=6cd15caa"
import script from "./BaseViewMode.vue?vue&type=script&lang=ts"
export * from "./BaseViewMode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports